import * as React from 'react';
import { Tabs, Tab } from 'react-bootstrap';

import { StudentPerformanceSummary } from './performance_summary'
import { StudentPracticeScores } from './practice_scores'
import { StudentStrengthWeaknesses } from './strength_weaknesses'
import { StudentUsageSummary } from './usage_summary'
import { StudentReportData } from './types';

import style from './style.module.scss';

export default (props: StudentReportData) => {
  return (
    <div>
      <h1>{props.name}</h1>
      <div className={style.email}>{props.email}</div>

      <Tabs id='student-report-subscription-tabs' bsStyle='pills'>
        {
          Object.keys(props.subscriptions).map((name, index) => {
            const subscription = props.subscriptions[name];

            return (
              <Tab className={style.brandingTab} title={name} key={name} eventKey={index}>
                <StudentPerformanceSummary {...subscription} />
                <StudentPracticeScores {...subscription} />
                <StudentStrengthWeaknesses {...subscription} />
                <StudentUsageSummary {...subscription} />
              </Tab>
            )
          })
        }
      </Tabs>
    </div>
  );
};
